import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AuthActions } from '@auth/state';
import { fromAuth } from '@auth/state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.store.select(fromAuth.selectAuthenticated).pipe(
      map((authenticated) => {
        if (!authenticated) {
          this.store.dispatch(AuthActions.SetAuthenticated({ authenticated: false }));
          void this.router.navigate(['login']);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
